export default __webpack_public_path__ + "static/3-c02ace6528d5d0c24e3081204c0fc364.png";